export * from './wall-type-4.component'